import { ca } from '@cian/analytics';

export const trackOpenOfferComplain = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Complain',
    action: 'open',
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};

export const trackCloseOfferComplain = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Complain',
    action: 'close',
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
